import { Button } from "@components/ui"
import { getSliceSubdomain } from "@utils/getSliceSubdomain"
import NextHead from "next/head"

function Page() {
  return (
    <>
      <NextHead>
        <meta property="fc:frame" content="vNext" />
        <meta
          property="fc:frame:image"
          content="https://slice.so/frames-assets/supercast-nft/default.png"
        />
        <meta
          property="fc:frame:post_url"
          content={`https://${getSliceSubdomain()}slice.so/api/frames/supercast-nft`}
        />
        <meta property="fc:frame:button:1" content="Mint" />
      </NextHead>
      <div className="text-center">
        <div className="pb-6 mx-auto prose">
          <p>Supercast NFT can only be minted on Farcaster.</p>
          <p className="text-sm text-gray-600">
            If you don&apos;t see the mint button, make sure you are on the
            latest version of Warpcast
          </p>
        </div>
        {/* TODO: generalize URL to be dynamic */}
        <Button label="Go to Farcaster" href="https://warpcast.com" />
      </div>
    </>
  )
}

export default Page
